import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
// Local lite middleware — reads Supabase session from localStorage instead of
// importing @supabase/auth-js on the home page. Saves ~220 KiB unused JS.
import { attachSupabaseAuth } from "@/lib/supabase-auth-attacher-lite";


const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  // Interna e-postrutter ska aldrig gå via omdirigeringar.
  const url = new URL(request.url);
  if (url.pathname.startsWith("/lovable/")) {
    return next();
  }
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  requestMiddleware: [errorMiddleware],
  functionMiddleware: [attachSupabaseAuth],
}));
